import { render } from "./cardAssetChange.vue?vue&type=template&id=953c4b50"
import script from "./cardAssetChange.vue?vue&type=script&lang=js"
export * from "./cardAssetChange.vue?vue&type=script&lang=js"

import "./cardAssetChange.vue?vue&type=style&index=0&id=953c4b50&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__